module.exports = __webpack_public_path__ + "img/logo.21d76c65.svg";